import tokenData from '../../design-tokens/base-tokens.json';
export const MuiSlider = {
    styleOverrides: {
        root: {
            color: tokenData.tokens.palette.blue.blue500,
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                cursor: 'not-allowed',
                pointerEvents: 'unset',
                '& .MuiSlider-thumb': {
                    background: tokenData.tokens.palette.grey.grey100,
                    border: `2px solid ${tokenData.tokens.palette.grey.disabled}`
                },
                '&& .MuiSlider-mark': {
                    color: tokenData.tokens.palette.grey.disabled
                },
                '&& .MuiSlider-markLabel': {
                    color: tokenData.tokens.palette.text.text100
                }
            }
        },
        rail: {
            height: 6,
            paddingRight: 5,
            '&:not(.Mui-disabled)': {
                color: tokenData.tokens.palette.grey.grey100,
                border: `0.5px solid ${tokenData.tokens.palette.grey.grey400}`
            }
        },
        track: {
            height: 8,
            marginLeft: '-2px'
        },
        thumb: {
            width: 24,
            height: 24,
            '&:hover': {
                boxShadow: `${tokenData.tokens.elevations[2]}, 0px 0px 0px 8px rgba(16, 116, 195, 0.16)`
            },
            '&:not(.Mui-disabled)': {
                background: tokenData.tokens.palette.background.white,
                border: `2px solid ${tokenData.tokens.palette.blue.blue500}`,
                boxShadow: tokenData.tokens.elevations[2],
                '&:hover': {
                    boxShadow: `${tokenData.tokens.elevations[2]}, 0px 0px 0px 8px rgba(16, 116, 195, 0.16)`
                },
                '&.Mui-focusVisible': {
                    boxShadow: `${tokenData.tokens.elevations[2]}, 0px 0px 0px 8px rgba(16, 116, 195, 0.16)`
                },
                '&.Mui-active': {
                    boxShadow: `${tokenData.tokens.elevations[2]}, 0px 0px 0px 14px rgba(16, 116, 195, 0.16)`
                }
            },
            '&.Mui-focusVisible': {
                '&:not(.Mui-active)': {
                    outline: `2px solid ${tokenData.tokens.palette.text.text300}`,
                    outlineOffset: 2
                }
            },
            '&:before': {
                boxShadow: 'none'
            }
        },
        valueLabel: ({ theme }) => ({
            background: tokenData.tokens.palette.grey.grey600,
            padding: theme.spacing(4, 6),
            borderRadius: '6px',
            ...theme.typography.body2
        }),
        mark: {
            color: tokenData.tokens.palette.grey.grey600,
            width: 4,
            height: 4,
            borderRadius: '50%',
            opacity: 1,
            transform: 'translate(0, -50%)'
        },
        markLabel: ({ theme }) => ({
            color: tokenData.tokens.palette.text.text300,
            ...theme.typography.caption
        }),
        markLabelActive: {
            color: tokenData.tokens.palette.red.red700
        },
        sizeSmall: {
            '& .MuiSlider-track': {
                height: 6,
                marginLeft: '-2px'
            },
            '& .MuiSlider-rail': {
                height: 3,
                paddingRight: 2
            },
            '& .MuiSlider-thumb': {
                width: 20,
                height: 20
            },
            '& .MuiSlider-mark': {
                width: 2,
                height: 2
            }
        }
    }
};
export default MuiSlider;
